import { render } from "./JuranetNavigationStructure.vue?vue&type=template&id=4e7bcc2a"
import script from "./JuranetNavigationStructure.vue?vue&type=script&lang=ts"
export * from "./JuranetNavigationStructure.vue?vue&type=script&lang=ts"
script.render = render

export default script